import moment from "moment";
export function isOutsideServiceHours(houseKeeping, settings) {
	console.log(houseKeeping, settings);
	if (
		!houseKeeping?.serviceTimingEnabled ||
		!houseKeeping?.serviceTiming?.from ||
		!houseKeeping?.serviceTiming?.to
	) {
		return false; // no restriction
	}

	const match = settings?.timezone?.match(/UTC([+-]\d{2}:\d{2})/);
	const offset = match ? match[1] : "+00:00";

	const now = moment().utcOffset(offset);
	const currentTime = now.format("HH:mm");

	const from = houseKeeping.serviceTiming.from; // "09:00"
	const to = houseKeeping.serviceTiming.to; // "17:00"

	console.log(
		`Timezone Offset: ${offset}, Current Time: ${currentTime}, Service Hours: ${from} - ${to}`,
	);

	return currentTime < from || currentTime > to;
}
